import React, { useState } from 'react';
import { Button } from './ui/button';
import { MessageSquare } from 'lucide-react';
import { SupportChatDialog } from './SupportChatDialog';

export const SupportChatButton = ({ contextType = 'manual' }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  
  const buttonLabel = contextType === 'manual' 
    ? 'CarCortex KI Benutzerhandbuch' 
    : 'CarCortex KI FAQ';

  return (
    <>
      <Button
        data-support-chat-trigger
        onClick={() => setIsChatOpen(true)}
        size="lg"
        className="fixed bottom-8 right-8 shadow-lg hover:scale-105 transition-all z-50 flex items-center gap-2"
        style={{
          backgroundColor: '#1EA0E6',
          color: '#FFFFFF',
          padding: '12px 20px',
          borderRadius: '50px',
          fontSize: '15px',
          fontWeight: '600'
        }}
      >
        <MessageSquare className="w-5 h-5" />
        {buttonLabel}
      </Button>

      <SupportChatDialog
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        contextType={contextType}
      />
    </>
  );
};
